<template>
  <div class="rt60">
    <!-- <top-nav></top-nav> -->
    <banner :child-data="fdata"></banner>
    <div id="product-main" class="container">
      <div class="product-info"></div>

      <div class="company-develop " data-ani="">
        <div class="develop-title">
          <span class="line"></span>
          <span class="title-text">{{$t('ProductTitle')}}</span>
          <span class="line"></span>
        </div>
        <div class="develop-main">
          <div class="bs-example bs-example-tabs" data-example-id="togglable-tabs">
            <div class="section row light">
              <div class="sec_left col-xs-12 col-md-12">
                <b-card>
                  <b-tabs card>
                    <b-tab :title="$t('Product0')" active>
                      <!-- <b-card-text>Tab contents 1</b-card-text> -->
                      <div class="tab-pane active sec_le_text" id="Scamera">
                        <div class="row first">
                          <div
                            class="row"
                            style="display: flex;justify-content: center;margin-bottom: 10%;"
                          >
                            <div class="col-md-5 col-xs-8 col-sm-6">
                              <img class="pw100" src="img/portfolio/scamera.png" alt />
                            </div>
                          </div>

                          <div class="info-title">
                            <span class="line"></span>
                            <span class="title-text">{{$t('Product0Int')}}</span>
                            <span class="line"></span>
                          </div>

                          <div class="col-xs-6 col-md-3 text-left">
                            <h3>{{$t('Product0secH0')}}</h3>
                            <p>{{$t('Product0secP0')}}</p>
                          </div>
                          <div class="col-xs-6 col-md-3 text-left">
                            <h3>{{$t('Product0secH1')}}</h3>
                            <p>{{$t('Product0secP1')}}</p>
                          </div>
                          <div class="col-xs-6 col-md-3 text-left">
                            <h3>{{$t('Product0secH2')}}</h3>
                            <p>{{$t('Product0secP2')}}</p>
                          </div>
                          <div class="col-xs-6 col-md-3 text-left">
                            <h3>{{$t('Product0secH3')}}</h3>
                            <p>{{$t('Product0secP3')}}</p>
                          </div>
                        </div>
                        <div class="row second">
                          <div class="info-title">
                            <span class="line"></span>
                            <span class="title-text">{{$t('Product0secTdesc')}}</span>
                            <span class="line"></span>
                          </div>
                          <div class="sec_left col-md-12">
                            <table class="table table-hover" id="table">
                              <thead>
                                <tr>
                                  <th>Category</th>
                                  <th>Item</th>
                                  <th>Description</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td
                                    rowspan="3"
                                    style="vertical-align: middle;width: 200px;"
                                  >Main Chipset</td>
                                  <td style="width: 250px;">SoC</td>
                                  <td>Amlogic Soc, 2 Cores CPU，4TOPS NPU</td>
                                </tr>
                                <tr>
                                  <td>RAM</td>
                                  <td>1GB DDR4</td>
                                </tr>
                                <tr>
                                  <td>ROM Storage</td>
                                  <td>4GB EMMC</td>
                                </tr>

                                <tr>
                                  <td rowspan="4" style="vertical-align: middle">Codec</td>
                                  <td>Coding standard</td>
                                  <td>H.265 / H.264 / MJPEG</td>
                                </tr>
                                <tr>
                                  <td>Coding rate</td>
                                  <td>4K@30fps + 1080p@30fps</td>
                                </tr>
                                <tr>
                                  <td>VBR and CBR</td>
                                  <td>Support</td>
                                </tr>
                                <tr>
                                  <td>Multi-channel</td>
                                  <td>Support</td>
                                </tr>

                                <tr>
                                  <td rowspan="7" style="vertical-align: middle">Camera</td>
                                  <td>ISP</td>
                                  <td>Up to 8M pixels</td>
                                </tr>
                                <tr>
                                  <td>Camera lens</td>
                                  <td>1.8mm-35mm prime lens</td>
                                </tr>
                                <tr>
                                  <td>Sensor</td>
                                  <td>
                                    Sony IMX307 / IMX326 / IMX415
                                    , OminiVision OS08A10
                                  </td>
                                </tr>
                                <tr>
                                  <td>Day and night mode</td>
                                  <td>IR-Cut filter</td>
                                </tr>
                                <tr>
                                  <td>WDR</td>
                                  <td>Yes</td>
                                </tr>
                                <tr>
                                  <td>Denoise</td>
                                  <td>2D/3D/Color noise reduction</td>
                                </tr>
                                <tr>
                                  <td>ROI</td>
                                  <td>Yes</td>
                                </tr>

                                <tr>
                                  <td>Image</td>
                                  <td>Image setting</td>
                                  <td>
                                    Adjustable saturation, brightness, contrast, sharpness,
                                    rollover, time of exposure, etc
                                  </td>
                                </tr>

                                <tr>
                                  <td rowspan="11" style="vertical-align: middle">Interface</td>
                                  <td>Protocol</td>
                                  <td>Onvif / GB28281</td>
                                </tr>
                                <tr>
                                  <td>Networking</td>
                                  <td>TCP/IP, HTTP,FTP,DHCP,DNS,DDNS,RTP,RTSP, NTP,UPnP,SMTP</td>
                                </tr>
                                <tr>
                                  <td>Network Interface</td>
                                  <td>RJ45 / WIFI</td>
                                </tr>
                                <tr>
                                  <td>Audio Output</td>
                                  <td>Support</td>
                                </tr>
                                <tr>
                                  <td>Audio input</td>
                                  <td>Support</td>
                                </tr>
                                <tr>
                                  <td>USB</td>
                                  <td>USB 2.0</td>
                                </tr>
                                <tr>
                                  <td>Storage</td>
                                  <td>TF Card</td>
                                </tr>
                                <tr>
                                  <td>UART</td>
                                  <td>GPIOAO(4x2.54mm fool proof connector/card)</td>
                                </tr>
                                <tr>
                                  <td>Reset</td>
                                  <td>1 key reset button</td>
                                </tr>
                                <tr>
                                  <td>System light (LED)</td>
                                  <td>1 GPIO(Green)</td>
                                </tr>
                                <tr>
                                  <td>Power light (LED)</td>
                                  <td>1 LED power light (Red)</td>
                                </tr>

                                <tr>
                                  <td>Dimension</td>
                                  <td>Size</td>
                                  <td>150mm(L)*70mm(W)*60mm (H)</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="row third">
                          <div class="info-title">
                            <span class="line"></span>
                            <span class="title-text">{{$t('ProductHLT')}}</span>
                            <span class="line"></span>
                          </div>
                          <div class="col-xs-6 col-md-4 text-left">
                            <h3>{{$t('ProductHLH0')}}</h3>
                            <p>{{$t('ProductHLP0')}}</p>
                          </div>
                          <div class="col-xs-6 col-md-4 text-left">
                            <h3>{{$t('ProductHLH1')}}</h3>
                            <p>{{$t('ProductHLP1')}}</p>
                          </div>
                          <div class="col-xs-6 col-md-4 text-left">
                            <h3>{{$t('ProductHLH2')}}</h3>
                            <p>{{$t('ProductHLP2')}}</p>
                          </div>
                        </div>
                      </div>
                    </b-tab>
                    <b-tab :title="$t('Product1')">
                      <!-- <b-card-text>Tab contents 2</b-card-text> -->
                      <div class="tab-pane sec_le_text" id="Ibox">
                        <div class="row first">
                          <div
                            class="row"
                            style="display: flex;justify-content: center;margin-bottom: 10%;"
                          >
                            <div class="col-md-5 col-xs-8 col-sm-6">
                              <img class="pw100" src="img/portfolio/ibox.jpg" alt />
                            </div>
                          </div>

                          <div class="info-title">
                            <span class="line"></span>
                            <span class="title-text">Introduction</span>
                            <span class="line"></span>
                          </div>
                          <div class="col-xs-6 col-md-3 text-left">
                            <h3>Built-in algorithms</h3>
                            <p>Face detection, face recognition, face-id and face deduplication</p>
                            <p>License plate recognition, automotive structured analysis</p>
                          </div>
                          <div class="col-xs-6 col-md-3 text-left">
                            <h3>Powerful NeuOS</h3>
                            <p>Support private algorithms integration, and algorithms customization</p>
                            <p>Metadata save to local storage or upload to remote server</p>
                            <p>Device function configuration UI</p>
                          </div>
                          <div class="col-xs-6 col-md-3 text-left">
                            <h3>Multi-channel video</h3>
                            <p>4-channel1080P/8-channel 720P</p>
                            <p>Support RTSP, MJPEG, UVC protocols</p>
                            <p>Every single channel runs independently</p>
                          </div>
                          <div class="col-xs-6 col-md-3 text-left">
                            <h3>Cloud service</h3>
                            <p>AI services and APIs</p>
                            <p>Device management</p>
                            <p>Public and private deployment</p>
                          </div>
                        </div>
                        <div class="row second">
                          <div class="info-title">
                            <span class="line"></span>
                            <span class="title-text">Specification</span>
                            <span class="line"></span>
                          </div>
                          <div class="sec_left col-md-12">
                            <table class="table table-hover" id="table2">
                              <thead>
                                <tr>
                                  <th>Category</th>
                                  <th>Item</th>
                                  <th>Description</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td
                                    rowspan="3"
                                    style="vertical-align: middle;width: 200px;"
                                  >Main Chipset</td>
                                  <td style="width: 250px;">SoC</td>
                                  <td>Amlogic Soc, 6 Cores CPU，5TOPS NPU</td>
                                </tr>
                                <tr>
                                  <td>RAM</td>
                                  <td>2GB DDR4</td>
                                </tr>
                                <tr>
                                  <td>ROM Storage</td>
                                  <td>8GB EMMC</td>
                                </tr>

                                <tr>
                                  <td rowspan="4" style="vertical-align: middle">Codec</td>
                                  <td>Coding standard</td>
                                  <td>H.265 / H.264 / MJPEG</td>
                                </tr>
                                <tr>
                                  <td>Coding rate</td>
                                  <td>1080p@60FPS</td>
                                </tr>
                                <tr>
                                  <td>Decoding standard</td>
                                  <td>H.265 / H.264 / VP9</td>
                                </tr>
                                <tr>
                                  <td>Decoding rate</td>
                                  <td>4Kx2K@60fps+1x1080P@60FPS</td>
                                </tr>

                                <tr>
                                  <td rowspan="7" style="vertical-align: middle">Camera</td>
                                  <td>ISP</td>
                                  <td>Up to 8M pixels</td>
                                </tr>
                                <tr>
                                  <td>Camera lens</td>
                                  <td>1.8mm-35mm prime lens</td>
                                </tr>
                                <tr>
                                  <td>Sensor</td>
                                  <td>
                                    Sony IMX307 / IMX326 / IMX415
                                    , OminiVision OS08A10
                                  </td>
                                </tr>
                                <tr>
                                  <td>Day and night mode</td>
                                  <td>IR-Cut filter</td>
                                </tr>
                                <tr>
                                  <td>WDR</td>
                                  <td>Yes</td>
                                </tr>
                                <tr>
                                  <td>Denoise</td>
                                  <td>2D/3D/Color noise reduction</td>
                                </tr>
                                <tr>
                                  <td>ROI</td>
                                  <td>Yes</td>
                                </tr>

                                <tr>
                                  <td rowspan="3" style="vertical-align: middle">Image</td>
                                  <td rowspan="2" style="vertical-align: middle">
                                    Resolution and
                                    frame rate
                                  </td>
                                  <td>50Hz: 25fps 1920×1080,1280×720</td>
                                </tr>
                                <tr>
                                  <td>60Hz: 30fps 1920×1080,1280×720</td>
                                </tr>
                                <tr>
                                  <td>Image setting</td>
                                  <td>
                                    Adjustable saturation, brightness, contrast, sharpness,
                                    rollover, time of exposure, etc
                                  </td>
                                </tr>

                                <tr>
                                  <td rowspan="12" style="vertical-align: middle">Interface</td>
                                  <td>Protocol</td>
                                  <td>Onvif / GB28281</td>
                                </tr>
                                <tr>
                                  <td>Networking</td>
                                  <td>TCP/IP, HTTP,FTP,DHCP,DNS,DDNS,RTP,RTSP, NTP,UPnP,SMTP</td>
                                </tr>
                                <tr>
                                  <td>Network Interface</td>
                                  <td>RJ45 / WIFI / 4G</td>
                                </tr>
                                <tr>
                                  <td>Audio Output</td>
                                  <td>Support</td>
                                </tr>
                                <tr>
                                  <td>Audio input</td>
                                  <td>Support</td>
                                </tr>
                                <tr>
                                  <td>USB</td>
                                  <td>USB 3.0 type-A & Micro USB 2.0</td>
                                </tr>
                                <tr>
                                  <td>Storage</td>
                                  <td>TF Card</td>
                                </tr>
                                <tr>
                                  <td>UART</td>
                                  <td>GPIOAO(4x2.54mm fool proof connector/card)</td>
                                </tr>
                                <tr>
                                  <td>Reset</td>
                                  <td>1 key reset button</td>
                                </tr>
                                <tr>
                                  <td>System light (LED)</td>
                                  <td>1 GPIO(Green)</td>
                                </tr>
                                <tr>
                                  <td>Power light (LED)</td>
                                  <td>1 LED power light (Red)</td>
                                </tr>
                                <tr>
                                  <td>Display</td>
                                  <td>HDMI</td>
                                </tr>

                                <tr>
                                  <td>Dimension</td>
                                  <td>Size</td>
                                  <td>110mm(L)*100mm(W)*33mm (H)</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="row third">
                          <div class="info-title">
                            <span class="line"></span>
                            <span class="title-text">{{$t('ProductHLT')}}</span>
                            <span class="line"></span>
                          </div>
                          <div class="col-xs-6 col-md-4 text-left">
                            <h3>{{$t('name')}}System Input</h3>
                            <p>{{$t('name')}}4-channel 1080P/8-channel 720P real-time video stream</p>
                          </div>
                          <div class="col-xs-6 col-md-4 text-left">
                            <h3>{{$t('name')}}</h3>
                            <p>{{$t('name')}}</p>
                          </div>
                          <div class="col-xs-6 col-md-4 text-left">
                            <h3>{{$t('name')}}</h3>
                            <p>{{$t('name')}}</p>
                          </div>
                        </div>
                      </div>
                    </b-tab>
                  </b-tabs>
                </b-card>

                <!-- 
                          <div class="sec_example">
                            <a href="./portfolio_detail.html?cate=mobile">Smart camera</a>
                            <a href="./portfolio_detail.html?cate=mobile">Intelligent box</a>
                </div>-->

                <div id="myTabContent" class="tab-content myTabContent"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="product-info"></div>
      <div class="product-info  " data-ani="" style="padding: 0;margin: 0 -15px">
        <div class="info-title">
          <span class="line"></span>
          <span class="title-text">{{$t('ProductAS')}}</span>
          <span class="line"></span>
        </div>
        <div class="info-main">
          <section class="strips">
            <article class="strips__strip">
              <div class="strip__content">
                <h1 class="strip__title" data-name="Lorem">{{$t('ProductAS0')}}</h1>
                <div class="strip__inner-text">
                  <p>{{$t('ProductAS0')}}</p>
                  <p style="font-size: 16px"></p>
                  <p>
                    <img style="width: 50%" src="img/lingshou.jpg" alt />
                  </p>
                </div>
              </div>
            </article>
            <article class="strips__strip">
              <div class="strip__content">
                <h1 class="strip__title" data-name="Ipsum">{{$t('ProductAS1')}}</h1>
                <div class="strip__inner-text">
                  <p>{{$t('ProductAS1')}}</p>
                </div>
              </div>
            </article>
            <article class="strips__strip">
              <div class="strip__content">
                <h1 class="strip__title" data-name="Dolor">{{$t('ProductAS2')}}</h1>
                <div class="strip__inner-text">
                  <p>{{$t('ProductAS2')}}</p>
                  <p style="font-size: 16px">{{$t('ProductASP2')}}</p>
                  <img style="width: 30%" src="img/zhaji.jpg" alt />
                </div>
              </div>
            </article>
            <article class="strips__strip">
              <div class="strip__content">
                <h1 class="strip__title" data-name="Sit">{{$t('ProductAS3')}}</h1>
                <div class="strip__inner-text">
                  <p>{{$t('ProductAS3')}}</p>
                  <p style="font-size: 16px">{{$t('ProductASP3')}}</p>
                  <p>
                    <img style="width: 50%" src="img/zhinengjiaju.png" alt />
                  </p>
                </div>
              </div>
            </article>
            <i class="fa fa-close strip__close"></i>
          </section>
        </div>
      </div>
    </div>
    <!-- <footer-bot></footer-bot> -->
  </div>
</template>

<script>
import "../../public/css/font-awesome.min.css";
import "../../public/lib/response_table.css";
import "../../public/lib/response_table.css";
import jQuery from "../../public/js/jquery.min.js";
import "../../public/lib/response_table.js";
import topNav from "../components/top";
import banner from "../components/banner";
import footerBot from "../components/footerBot";
import { mapMutations } from "vuex";

export default {
  name: "product",
  components: {
    topNav,
    banner,
    footerBot
  },
  data() {
    return {
      fdata: {
        h1: "Product",
        menu: '',
        h2: "AI on device for you all",
        style: {
          background:
            "url(../img/product/cpzx_banner@3x.jpg)  center top 100% no-repeat ",
          backgroundSize: "100% 100%"
        }
      }
    };
  },
  methods: {
    ...mapMutations(["editMenu"])
  },
  watch: {
    $route(to, from) {
        if (to.query.id) {
          this.menu = to.query.id
          console.log(this.menu)
        } else {
          this.menu = 'face'
        }
    }
  },
  mounted() {
    jQuery("#table").basictable();
    this.editMenu("product");
    var Expand = (function() {
      var tile = $(".strips__strip");
      var tileLink = $(".strips__strip > .strip__content");
      var tileText = tileLink.find(".strip__inner-text");
      var stripClose = $(".strip__close");
      var expanded = false;
      var open = function() {
        var tile = $(this).parent();
        if (!expanded) {
          tile.addClass("strips__strip--expanded");
          tileText.css(
            "transition",
            "all .6s 1s cubic-bezier(0.23, 1, 0.32, 1)"
          );
          stripClose.addClass("strip__close--show");
          stripClose.css(
            "transition",
            "all .6s 1s cubic-bezier(0.23, 1, 0.32, 1)"
          );
          expanded = true;
        }
      };
      var close = function() {
        if (expanded) {
          tile.removeClass("strips__strip--expanded");
          tileText.css(
            "transition",
            "all 0.05s 0 cubic-bezier(0.23, 1, 0.32, 1)"
          );
          stripClose.removeClass("strip__close--show");
          stripClose.css(
            "transition",
            "all 0.2s 0s cubic-bezier(0.23, 1, 0.32, 1)"
          );
          expanded = false;
        }
      };
      var bindActions = function() {
        tileLink.on("click", open);
        stripClose.on("click", close);
      };
      var init = function() {
        bindActions();
      };

      return {
        init: init
      };
    })();
    Expand.init();
  }
};
</script>

<style scoped>
blockquote {
  border: none;
}

#navbar-main {
}

#product-main {
  padding-bottom: 30px;
}

h3 {
  color: #0085cb;
}

#headerwrap {
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
#headerwrap h1 {
  margin-top: 0;
}

#headerwrap h2 {
  color: white;
  margin-bottom: 0;
}

#product-main .img-banner h3 {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 40px;
}

@media screen and (max-width: 480px) {
  #product-main .img-banner {
    height: 170px;
    width: 100%;
    background: url(../../public/img/product/cpzx_banner@3x.jpg) no-repeat
      center;
    background-size: 100% 100%;
  }
}

#product-main .product-info {
  /* padding: 50px 0px; */
  box-sizing: border-box;
}

#product-main .info-title,
#product-main .develop-title {
  margin-bottom: 10px;
  margin-top: 20px;
  background: skyblue;
  /* color: white; */
  border-radius: 20px;
  padding: 10px;
  margin-bottom: 40px;
  /* background: orange; */
  border-radius: 24px;
  padding: 10px 30px;
  color: white;
  text-align: left;
  width: 100%;
}

#product-main .info-title {
  margin-top: 80px;
}
#product-main .info-main {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
}

#product-main .info-main img {
  width: 100%;
}

#product-main .info-title .title-text,
#product-main .develop-title .title-text {
  font-size: 30px;
  color: white;
}

.company-develop {
  width: 100%;
  margin: 0 auto;
  padding-top: 40px;
}

@media screen and (max-width: 480px) {
  .company-develop {
    width: 100%;
    margin: 0 auto;
  }
}

.company-develop #myTabs {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
}

.company-develop #myTabs li {
  flex: 1;
  text-align: center;
}

.case-core {
  overflow: hidden;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 413px;
  transition: background-image 0.5s;
  margin-bottom: 60px;
  background-color: #08061e;
}

.case-core-list {
  height: 100%;
  width: 25%;
  float: left;
  border-right: 1px solid rgba(255, 255, 255, 0.4);
  padding: 100px 35px 0;
  position: relative;
  transition: all 0.5s;
  cursor: pointer;
}

.en .case-core-list {
  padding-top: 50px;
}

.case-core.cell1 .case-core-list {
  width: 100%;
  border-right: none;
}

.case-core.cell2 .case-core-list {
  width: 50%;
}

.case-core.cell3 .case-core-list {
  width: 33.33%;
}

.case-core-hover .case-core-list {
  padding-top: 62px;
  width: 20%;
}

.en .case-core-hover .case-core-list {
  padding-top: 20px;
}

.case-core-hover.cell2 .case-core-list {
  width: 33.3%;
}

.case-core-hover.cell3 .case-core-list {
  width: 25%;
}

.case-core-hover .case-core-list.current {
  width: 40%;
}

.case-core-hover.cell1 .case-core-list.current {
  width: 100%;
}

.case-core-hover.cell2 .case-core-list.current {
  width: 66.7%;
}

.case-core-hover.cell3 .case-core-list.current {
  width: 50%;
}

.case-core-list:last-of-type {
  border-right: none;
}

.case-core-list .case-logo {
  height: 58px;
  margin-bottom: 10px;
}

.case-core-list .case-title {
  font-size: 20px;
  line-height: 150%;
  margin-bottom: 10px;
  color: #fff;
}

.case-logo img {
  height: 100%;
  width: auto;
}

.case-summary h3 {
  font-size: 20px;
  color: #ffffff;
  line-height: 150%;
  margin-bottom: 15px;
}

.en .case-summary h3 {
  text-align: left;
}

.case-summary p {
  font-size: 14px;
  color: #ffffff;
  line-height: 150%;
  transition: all 0.5s;
  opacity: 0;
}

.case-core-list.current .case-summary p {
  opacity: 0.8;
}

.case-more-btn {
  height: 48px;
  width: 82px;
  /* background: rgba(0, 0, 0, 0.2) url(/sites/all/themes/yitu/images/more2.svg) */
  /* no-repeat center 18px; */
  border-radius: 24px;
  position: absolute;
  left: 35px;
  bottom: 70px;
  transition: all 0.5s;
  display: none;
}

.case-core-list.current .case-more-btn {
  opacity: 0;
}

.case-wrapper {
  padding: 80px 0;
  background: #fff;
}

.case-type {
  width: 140px;
  float: left;
}

.case-list {
  width: calc(100% - 140px);
  float: right;
}

.case-type .form-type-bef-link,
.case-type li {
  font-family: PingFangSC-Medium;
  color: #000000;
  width: 100%;
}

.case-type .form-type-bef-link a,
.case-type li a {
  color: #7f7f7f;
  padding: 12px 0 12px 24px;
  font-size: 18px;
  line-height: 150%;
  position: relative;
  width: 100%;
  display: block;
  transition: all 0.5s;
}

.case-type .form-type-bef-link a:before,
.case-type li a:before {
  position: absolute;
  content: "";
  display: block;
  width: 2px;
  height: 100%;
  left: 0;
  top: 0;
  overflow: hidden;
  background: #000;
  opacity: 0.1;
}

.case-type .form-type-bef-link a.active,
.case-type li.active a {
  color: #000;
}

.case-type .form-type-bef-link a.active:before,
.case-type li.active a:before {
  background-image: linear-gradient(-90deg, #6acaff 0%, #0b1cba 100%);
  opacity: 1;
}

.case-list ul {
  padding-left: 9px;
  margin-bottom: 0;
}

.case-list li {
  position: relative;
  width: 100%;
  background: #f4f5f9;
  padding: 60px;
  margin-bottom: 24px;
}

.case-list li h3 {
  font-size: 20px;
  color: #000000;
  margin-bottom: 20px;
}

.case-list li p {
  opacity: 0.7;
  font-size: 16px;
  color: #000000;
  line-height: 26px;
}

.case-list li span.type {
  display: block;
  height: 30px;
  padding: 0 10px;
  text-align: center;
  font-size: 16px;
  line-height: 28px;
  position: absolute;
  left: -9px;
  top: 12px;
  border-width: 1px;
  border-style: solid;
  background-color: #fff;
}

.case-list li span.type:before {
  content: "";
  display: block;
  width: 10px;
  height: 6px;
  position: absolute;
  left: -1px;
  bottom: -7px;
  background-position: 0 0;
  background-repeat: no-repeat;
  background-size: 10px;
}

.case-list li span.type.yuanqu {
  color: #189583;
  border-color: rgba(24, 149, 131, 0.1);
}

.case-list li span.type.yuanqu:before {
  /* background-image: url(/sites/all/themes/yitu/images/flag-yq.svg); */
}

.case-list li span.type.lingshou {
  color: #e07f16;
  border-color: rgba(224, 127, 22, 0.1);
}

.case-list li span.type.lingshou:before {
  /* background-image: url(/sites/all/themes/yitu/images/flag-ls.svg); */
}

.case-list li span.type.yiliao {
  color: #0060ff;
  border-color: rgba(0, 96, 255, 0.1);
}

.case-list li span.type.yiliao:before {
  /* background-image: url(/sites/all/themes/yitu/images/flag-yl.svg); */
}

.case-list li span.type.anfang {
  color: #000aff;
  border-color: rgba(0, 10, 255, 0.1);
}

.case-list li span.type.anfang:before {
  /* background-image: url(/sites/all/themes/yitu/images/flag-af.svg); */
}

.case-list li span.type.jinrong {
  color: #a38f33;
  border-color: rgba(163, 143, 51, 0.1);
}

.case-list li span.type.jinrong:before {
  /* background-image: url(/sites/all/themes/yitu/images/flag-jr.svg); */
}

.case-list li span.type.aicity {
  color: #a95454;
  border-color: rgba(169, 84, 84, 0.1);
}

.case-list li span.type.aicity:before {
  /* background-image: url(/sites/all/themes/yitu/images/flag-other.svg); */
}

.case-list li span.type.others {
  color: #e55354;
  border-color: rgba(69, 84, 184, 0.1);
}

.case-list li span.type.others:before {
  /* background-image: url(/sites/all/themes/yitu/images/flag-other.svg); */
}

[class^="icon-"],
[class*=" icon-"] {
  font-family: icomoon;
  speak: none;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body,
html {
  font-size: 100%;
  padding: 0;
  margin: 0;
}

*,
*:after,
*:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.clearfix:before,
.clearfix:after {
  content: " ";
  display: table;
}

.clearfix:after {
  clear: both;
}

a {
  color: #2fa0ec;
  text-decoration: none;
  outline: 0;
}

a:hover,
a:focus {
  color: #74777b;
}

.htmleaf-container {
  margin: 0 auto;
  text-align: center;
  overflow: hidden;
}

.htmleaf-content {
  font-size: 150%;
  padding: 1em 0;
}

.htmleaf-content h2 {
  margin: 0 0 2em;
  opacity: 0.1;
}

.htmleaf-content p {
  margin: 1em 0;
  padding: 5em 0 0;
  font-size: 0.65em;
}

.bgcolor-1 {
  background: #f0efee;
}

.bgcolor-2 {
  background: #f9f9f9;
}

.bgcolor-3 {
  background: #e8e8e8;
}

.bgcolor-4 {
  background: #2f3238;
  color: #fff;
}

.bgcolor-5 {
  background: #df6659;
  color: #521e18;
}

.bgcolor-6 {
  background: #2fa8ec;
}

.bgcolor-7 {
  background: #d0d6d6;
}

.bgcolor-8 {
  background: #3d4444;
  color: #fff;
}

.bgcolor-9 {
  background: #ef3f52;
  color: #fff;
}

.bgcolor-10 {
  background: #64448f;
  color: #fff;
}

.bgcolor-11 {
  background: #3755ad;
  color: #fff;
}

.bgcolor-12 {
  background: #3498db;
  color: #fff;
}

.htmleaf-header {
  padding: 1em 190px;
  letter-spacing: -1px;
  text-align: center;
}

.htmleaf-header h1 {
  font-weight: 600;
  font-size: 2em;
  line-height: 1;
  margin-bottom: 0;
  font-family: segoe ui, lucida grande, Helvetica, Arial, microsoft yahei,
    FreeSans, Arimo, droid sans, wenquanyi micro hei, hiragino sans gb,
    hiragino sans gb w3, fontawesome, sans-serif;
}

.htmleaf-header h1 span {
  font-family: segoe ui, lucida grande, Helvetica, Arial, microsoft yahei,
    FreeSans, Arimo, droid sans, wenquanyi micro hei, hiragino sans gb,
    hiragino sans gb w3, fontawesome, sans-serif;
  display: block;
  font-size: 60%;
  font-weight: 400;
  padding: 0.8em 0 0.5em;
  color: #c3c8cd;
}

.htmleaf-demo a {
  color: #1d7db1;
  text-decoration: none;
}

.htmleaf-demo {
  width: 100%;
  padding-bottom: 1.2em;
}

.htmleaf-demo a {
  display: inline-block;
  margin: 0.5em;
  padding: 0.6em 1em;
  border: 3px solid #1d7db1;
  font-weight: 700;
}

.htmleaf-demo a:hover {
  opacity: 0.6;
}

.htmleaf-demo a.current {
  background: #1d7db1;
  color: #fff;
}

.htmleaf-links {
  position: relative;
  display: inline-block;
  white-space: nowrap;
  font-size: 1.5em;
  text-align: center;
}

.htmleaf-links::after {
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -1px;
  width: 2px;
  height: 100%;
  background: #dbdbdb;
  content: "";
  -webkit-transform: rotate3d(0, 0, 1, 22.5deg);
  transform: rotate3d(0, 0, 1, 22.5deg);
}

.htmleaf-icon {
  display: inline-block;
  margin: 0.5em;
  padding: 0;
  width: 1.5em;
  text-decoration: none;
}

.htmleaf-icon span {
  display: none;
}

.htmleaf-icon:before {
  margin: 0 5px;
  text-transform: none;
  font-weight: 400;
  font-style: normal;
  font-variant: normal;
  font-family: icomoon;
  line-height: 1;
  speak: none;
  -webkit-font-smoothing: antialiased;
}

.htmleaf-footer {
  width: 100%;
  padding-top: 10px;
}

.htmleaf-small {
  font-size: 0.8em;
}

.center {
  text-align: center;
}

.related {
  color: #fff;
  background: #333;
  text-align: center;
  font-size: 1.25em;
  padding: 0.5em 0;
  overflow: hidden;
}

.related > a {
  vertical-align: top;
  width: calc(100% - 20px);
  max-width: 340px;
  display: inline-block;
  text-align: center;
  margin: 20px 10px;
  padding: 25px;
  font-family: segoe ui, lucida grande, Helvetica, Arial, microsoft yahei,
    FreeSans, Arimo, droid sans, wenquanyi micro hei, hiragino sans gb,
    hiragino sans gb w3, fontawesome, sans-serif;
}

.related a {
  display: inline-block;
  text-align: left;
  margin: 20px auto;
  padding: 10px 20px;
  opacity: 0.8;
  -webkit-transition: opacity 0.3s;
  transition: opacity 0.3s;
  -webkit-backface-visibility: hidden;
}

.related a:hover,
.related a:active {
  opacity: 1;
}

.related a img {
  max-width: 100%;
  opacity: 0.8;
  border-radius: 4px;
}

.related a:hover img,
.related a:active img {
  opacity: 1;
}

.related h3 {
  font-family: microsoft yahei, sans-serif;
}

.related a h3 {
  font-weight: 300;
  margin-top: 0.15em;
  color: #fff;
}

.icon-htmleaf-home-outline:before {
  content: "\e5000";
}

.icon-htmleaf-arrow-forward-outline:before {
  content: "\e5001";
}

@media screen and (max-width: 50em) {
  .htmleaf-header {
    padding: 3em 10% 4em;
  }

  .htmleaf-header h1 {
    font-size: 2em;
  }
}

@media screen and (max-width: 40em) {
  .htmleaf-header h1 {
    font-size: 1.5em;
  }
}

@media screen and (max-width: 30em) {
  .htmleaf-header h1 {
    font-size: 1.2em;
  }
}

.strips {
  min-height: 50vh;
  text-align: center;
  overflow: hidden;
  color: #fff;
  width: 100%;
  position: relative;
}

.strips__strip {
  will-change: width, left, z-index, height;
  position: absolute;
  width: 25%;
  min-height: 46vh;
  overflow: hidden;
  cursor: pointer;
  -webkit-transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.strips__strip:nth-child(1) {
  left: 0;
}

.strips__strip:nth-child(2) {
  left: 15vw;
}

.strips__strip:nth-child(3) {
  left: 30vw;
}

.strips__strip:nth-child(4) {
  left: 45vw;
}

.strips__strip:nth-child(1) .strip__content {
  background: #244f75;
  -webkit-transform: translate3d(-100%, 0, 0);
  transform: translate3d(-100%, 0, 0);
  -webkit-animation-name: strip1;
  animation-name: strip1;
  -webkit-animation-delay: 0.1s;
  animation-delay: 0.1s;
}

.strips__strip:nth-child(2) .strip__content {
  background: #60bfbf;
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
  -webkit-animation-name: strip2;
  animation-name: strip2;
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}

.strips__strip:nth-child(3) .strip__content {
  background: #8c4b7e;
  -webkit-transform: translate3d(0, -100%, 0);
  transform: translate3d(0, -100%, 0);
  -webkit-animation-name: strip3;
  animation-name: strip3;
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
}

.strips__strip:nth-child(4) .strip__content {
  background: #f8bb44;
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
  -webkit-animation-name: strip4;
  animation-name: strip4;
  -webkit-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

@media screen and (max-width: 760px) {
  .strips__strip {
    min-height: 12vh;
  }

  .strips__strip:nth-child(1) {
    top: 0;
    left: 0;
    width: 100%;
  }

  .strips__strip:nth-child(2) {
    top: 12vh;
    left: 0;
    width: 100%;
  }

  .strips__strip:nth-child(3) {
    top: 24vh;
    left: 0;
    width: 100%;
  }

  .strips__strip:nth-child(4) {
    top: 36vh;
    left: 0;
    width: 100%;
  }
}

.strips .strip__content {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-decoration: none;
}

.strips .strip__content:hover:before {
  -webkit-transform: skew(-30deg) scale(3) translate(0, 0);
  -ms-transform: skew(-30deg) scale(3) translate(0, 0);
  transform: skew(-30deg) scale(3) translate(0, 0);
  opacity: 0.1;
}

.strips .strip__content:before {
  content: "";
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  opacity: 0.05;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
  transform-origin: center center;
  -webkit-transform: skew(-30deg) scaleY(1) translate(0, 0);
  -ms-transform: skew(-30deg) scaleY(1) translate(0, 0);
  transform: skew(-30deg) scaleY(1) translate(0, 0);
  -webkit-transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.ai_office {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  justify-content: center;
}

.ai_office > img {
  width: 70px !important;
  height: 60px;
  margin-right: 20px;
}

.ai_office p:nth-child(2) {
  font-size: 16px !important;
  margin-bottom: 0;
  text-align: left;
}

.mainAi {
  display: flex;
  flex-wrap: wrap;
}

.ai_sec {
  width: 50%;
}

.ai_sec > p {
  font-size: 20px;
}

.strips .strip__inner-text {
  will-change: transform, opacity;
  position: absolute;
  z-index: 5;
  top: 50%;
  left: 50%;
  width: 70%;
  -webkit-transform: translate(-50%, -50%) scale(0.5);
  -ms-transform: translate(-50%, -50%) scale(0.5);
  transform: translate(-50%, -50%) scale(0.5);
  opacity: 0;
  -webkit-transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.strips__strip--expanded {
  width: 100%;
  top: 0 !important;
  left: 0 !important;
  z-index: 3;
  cursor: default;
}

@media screen and (max-width: 760px) {
  .strips__strip--expanded {
    min-height: 48vh;
  }
}

.strips__strip--expanded .strip__content:hover:before {
  -webkit-transform: skew(-30deg) scale(1) translate(0, 0);
  -ms-transform: skew(-30deg) scale(1) translate(0, 0);
  transform: skew(-30deg) scale(1) translate(0, 0);
  opacity: 0.05;
}

.strips__strip--expanded .strip__title {
  opacity: 0;
}

.strips__strip--expanded .strip__inner-text {
  opacity: 1;
  -webkit-transform: translate(-50%, -50%) scale(1);
  -ms-transform: translate(-50%, -50%) scale(1);
  transform: translate(-50%, -50%) scale(1);
}

.strips__strip--expanded .strip__inner-text p {
  font-size: 24px;
}

.strip__title {
  display: block;
  margin: 0;
  position: relative;
  z-index: 2;
  width: 100%;
  font-size: 40px;
  color: #fff;
  -webkit-transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

@media screen and (max-width: 760px) {
  .strip__title {
    font-size: 28px;
  }
}

.strip__close {
  position: absolute;
  right: 3vw;
  top: 3vw;
  opacity: 0;
  z-index: 10;
  -webkit-transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  cursor: pointer;
  -webkit-transition-delay: 0.5s;
  transition-delay: 0.5s;
}

.strip__close--show {
  opacity: 1;
  font-size: 30px;
}

.pw100 {
  width: 100%;
  margin-top: 10%;
}

@-webkit-keyframes strip1 {
  0% {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes strip1 {
  0% {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@-webkit-keyframes strip2 {
  0% {
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes strip2 {
  0% {
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@-webkit-keyframes strip3 {
  0% {
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes strip3 {
  0% {
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@-webkit-keyframes strip4 {
  0% {
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes strip4 {
  0% {
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
.rt60 {
  position: relative;
  top: -60px;
  margin-bottom: -60px;
}
.myBtn:active {
  background-color:unset !important;
  color: unset;
}
.myBtn:focus {
  outline: 0 !important;
}
</style>